/**
 * Created by DynamicDog on 2016-12-13.
 *
 * Simple component that displays the header image and button to create a new project.
 * TODO: Add alert if there's already a project started.
 */
import {Component} from '@angular/core';
import {EtikettService} from "./services/etikett.service";
import {TranslateService} from "./services/translate.service";

@Component({
    selector: 'intro-view',
    template: `
            <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
            <meta http-equiv="Pragma" content="no-cache">
            <meta http-equiv="Expires" content="0">
            <div class="intro" [style.background-image]=backgroundImage>
                
                <div *ngIf="etikettService.mode==='create'" class="content">
                    <h1 id="intro-title">{{'intro-title'|translate}}</h1>
                    <h2 id="intro-text">{{'intro-text'|translate}}</h2>
                    
                </div>
                
                <div *ngIf="etikettService.mode==='upload'" class="content">
                    <div class="competition-instructions">
                        <h2>{{'Vinn resa & boende för familjen till Gränna'|translate}}</h2>
                        <div><b>1. </b>{{'Gör ditt allra bästa recept (marmelad, senap, eller liknande).'|translate}}</div>
                        <div><b>2. </b>{{'Skapa en etikett med Etikettmaskinen som du fäster på ditt verk.'|translate}}</div>
                        <div><b>3. </b><span [innerHTML]="translate.translate('Ladda upp ett foto och dela på sociala medier med #Etikettmaskinen, @DanSukker, samt beskriv de tre mest utmärkande ingredienserna i receptet')"></span></div>
                    </div>
                    <div>{{'Vinnaren presenteras här på sajten den XX mars'|translate}}</div>                    
                </div>
            </div>
            <div class="advicetext"><p id="intro-info">{{'intro-info'|translate}}</p></div>
            <div *ngIf="etikettService.mode==='upload'" class="competition-links">
                <div class="menu">
                    <div class="menu-item" (click)="onScrollTo('bidrag')">{{'BIDRAG'|translate}}</div>
                    <div class="menu-item" (click)="onScrollTo('priser')">{{'PRISER'|translate}}</div>
                    <div class="menu-item" (click)="onScrollTo('regler')">{{'TÄVLINGSREGLER'|translate}}</div>
                </div>
            </div>
        `,
})
export class IntroViewComponent {
    backgroundImage:string = "";
    constructor(public etikettService:EtikettService,private translate:TranslateService) {
        var image = translate.translate('header-image');
        
        if(image.startsWith('*')) {
            image = 'bg1.jpg';
        }
        this.backgroundImage = 'url("css/images/'+image+'")';//translate.translate("header-image");
    }

    private onScrollTo(name:string):void {
    }
}


// WEBPACK FOOTER //
// ./app/intro.view.ts